const CloseIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5104 1.01041L1.48959 13.0312M13.5104 13.0312L1.48959 1.01041" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CloseIcon;
